import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-new-radio',
  templateUrl: './radio.component.html',
})
export class NewRadioComponent {
  @Input() options: any[] = [];
  @Input() value: any;
  @Input() inline: boolean = false;
  @Input() selectedValue: string = '';
  @Output() sendValueChange = new EventEmitter();

  onOptionSelected(id: string) {
    this.sendValueChange.emit(id);
  }
}
